interface LoadingSkeletonProps {
  count?: number;
  className?: string;
}

export const LoadingSkeleton = ({
  count = 4,
  className = 'h-32 bg-gray-100 rounded animate-pulse',
}: LoadingSkeletonProps) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={className} />
      ))}
    </div>
  );
};

export const LoadingDot = () => (
  <div className="w-3 h-3 bg-gray-300 rounded-full animate-pulse" />
);
